import { useState, useEffect } from 'react';

/**
 * Custom hook that tracks the window's inner height
 * @returns Current screen height in pixels
 */
function useScreenHeight(): number {
    // Initialize state with current screen height or 0 if window is undefined
    const [screenHeight, setScreenHeight] = useState<number>(typeof window !== 'undefined' ? window.innerHeight : 0);

    /**
     * Updates the screen height state
     * Includes a delayed update to handle mobile browser UI transitions
     */
    const handleResize = (): void => {
        setScreenHeight(window.innerHeight);
        setTimeout(() => {
            setScreenHeight(window.innerHeight);
        }, 100);
    };

    useEffect(() => {
        // Set initial height
        handleResize();

        // Add event listener for resize events
        window.addEventListener('resize', handleResize);

        // Cleanup function
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return screenHeight;
}

export default useScreenHeight;
